import { LocationDtoTypeEnum } from "../generated/account-client";

export const PAUSE_PERIODS = [1, 3];

function initMonths() {
  let date = new Date(2021, 0, 1);
  const months: { [month: number]: string } = {};
  for (let step = 0; step < 12; step++) {
    months[step + 1] = date.toLocaleString("en-us", { month: "short" });
    date = new Date(date.setMonth(date.getMonth() + 1));
  }

  return months;
}

function initYears() {
  let date = new Date();
  const years = [] as number[];

  for (let step = 0; step < 10; step++) {
    years.push(date.getFullYear());
    date = new Date(date.setFullYear(date.getFullYear() + 1));
  }

  return years;
}

export const CC_MONTHS = initMonths();
export const CC_YEARS = initYears();

export const BUSINESS_TYPE = [
  LocationDtoTypeEnum.Restaurant,
  LocationDtoTypeEnum.Spa,
  LocationDtoTypeEnum.Designer,
  LocationDtoTypeEnum.Dispensary,
  LocationDtoTypeEnum.Other,
];
export const ALLOWED_IMAGE_TYPES =
  "image/png,image/x-png,image/jpeg,/image/jpg";
export const MAX_IMAGE_SIZE = 10;
export const fallbackImage =
  "data:image/png;base64,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";
export const DEFAULT_ADDON_PRICE = 10;

export const DesignSizes = JSON.parse(`{
  "letter" : ["flyer", "8.5 x 11"],
  "letter-landscape" : ["flyer", "11 x 8.5"],
  "legal" : ["flyer", "8.5 x 14"],
  "legal-landscape" : ["flyer", "14 x 8.5"],
  "tabloid" : ["flyer", "11 x 17"],
  "tabloid-landscape" : ["flyer", "17 x 11"],
  "a4" : ["flyer", "8.3 x 11.7"],
  "a4-landscape" : ["flyer", "11.7 x 8.3"],
  "fb-post" : ["social", "1200 x 628"],
  "fb-story" : ["social", "1080 x 1920"],
  "insta-post" : ["social", "1080 x 1080"],
  "insta-story" : ["social", "1080 x 1920"],
  "biz-card-landscape" : ["business card", "3.5 x 2"],
  "biz-card-portrait" : ["business card", "2 x 3.5"],
  "biz-card-square" : ["business card", "2.5 x 2.5"],
  "menu-letter" : ["menu", "8.5 x 11"],
  "menu-letter-landscape" : ["menu", "11 x 8.5"],
  "menu-legal" : ["menu", "8.5 x 14"],
  "menu-legal-landscape" : ["menu", "14 x 8.5"],
  "menu-tabloid" : ["menu", "11 x 17"],
  "menu-tabloid-landscape" : ["menu", "17 x 11"],
  "menu-a4" : ["menu", "8.3 x 11.7"],
  "menu-a4-landscape" : ["menu", "11.7 x 8.3"],
  "loyalty-card-landscape" : ["loyalty card", "3.5 x 2"],
  "loyalty-card-portrait" : ["loyalty card", "2 x 3.5"],
  "kids-menu-letter-portrait" : ["menu", "8.5 x 11"],
  "kids-menu-letter-landscape" : ["menu", "11 x 8.5"],
  "kids-menu-legal-portrait" : ["menu", "8.5 x 14"],
  "kids-menu-legal-landscape" : ["menu", "14 x 8.5"],
  "kids-menu-tabloid-portrait" : ["menu", "11 x 17"],
  "kids-menu-tabloid-landscape" : ["menu", "17 x 11"],
  "kids-menu-a4-portrait" : ["menu", "8.3 x 11.7"],
  "kids-menu-a4-landscape" : ["menu", "11.7 x 8.3"],
  "comment-card-portrait" : ["comment card", "3.5 x 8.5"],
  "rack-card-portrait" : ["rack card", "3.5 x 8.5"],
  "gift-certificate-landscape" : ["gift certificate", "8.5 x 3.5"],
  "takeout-letter-trifold" : ["takeout", "11 x 8.5"],
  "takeout-letter-bifold" : ["takeout", "11 x 8.5"],
  "takeout-legal-trifold" : ["takeout", "14 x 8.5"],
  "takeout-legal-quadfold" : ["takeout", "14 x 8.5"],
  "takeout-tabloid-trifold" : ["takeout", "17 x 11"],
  "folded-menu-letter-trifold" : ["folded menu", "11 x 8.5"],
  "folded-menu-letter-bifold" : ["folded menu", "11 x 8.5"],
  "folded-menu-legal-trifold" : ["folded menu", "14 x 8.5"],
  "folded-menu-tabloid-trifold" : ["folded menu", "17 x 11"],
  "half-page-menu" : ["menu", "4.25 x 11"],
  "half-page-menu-long" : ["menu", "4.25 x 14"],
  "half-page-menu-wide" : ["menu", "5.5 x 8.5"],
  "half-page-menu-wide-landscape" : ["menu", "8.5 x 5.5"],
  "table-tent" : ["table tent", "4 x 6"],
  "table-tent-insert" : ["tabletop insert", "5 x 7"],
  "table-tent-insert-4x6" : ["tabletop insert", "4 x 6"],
  "poster" : ["poster", "22 x 28"],
  "digital-menu-board" : ["menu", "16 x 9"],
  "digital-menu-board-portrait" : ["menu", "9 x 16"],
  "menu-mailer-tabloid-trifold" : ["menu", "17 x 11"],
  "sticker-landscape" : ["sticker", "3.5 x 2"],
  "sticker-portrait" : ["sticker", "2 x 3.5"],
  "sticker-square" : ["sticker", "2.5 x 2.5"],
  "label-landscape" : ["label", "3.5 x 2"],
  "label-portrait" : ["label", "2 x 3.5"],
  "label-square" : ["label", "2.5 x 2.5"],
  "sandwich-board" : ["sandwich board", "22 x 28"],
  "logo" : ["logo", "1000 x 1000"]
}`);

export const FilterSizesMap = JSON.parse(`{
  "all-categories": [],
  "menu": ["menu-letter", "menu-letter-landscape", "menu-legal", "menu-legal-landscape", "menu-tabloid", "menu-tabloid-landscape", "menu-a4", "menu-a4-landscape", "folded-menu-letter-trifold", "folded-menu-letter-bifold", "folded-menu-legal-trifold", "folded-menu-tabloid-trifold", "menu-mailer-tabloid-trifold"],
  "digital-menu-board": ["digital-menu-board", "digital-menu-board-portrait"],
  "table-tent": [],
  "takeout": ["takeout-letter-trifold", "takeout-letter-bifold", "takeout-legal-trifold", "takeout-legal-quadfold", "takeout-tabloid-trifold"],
  "half-page-menu": ["half-page-menu", "half-page-menu-long", "half-page-menu-wide", "half-page-menu-wide-landscape"],
  "flyer": ["letter", "letter-landscape", "legal", "legal-landscape", "tabloid", "tabloid-landscape", "a4", "a4-landscape"],
  "kids-menu": ["kids-menu-letter-portrait", "kids-menu-letter-landscape", "kids-menu-legal-portrait", "kids-menu-legal-landscape", "kids-menu-tabloid-portrait", "kids-menu-tabloid-landscape", "kids-menu-a4-portrait", "kids-menu-a4-landscape"],
  "poster": ["poster"],
  "business-card": ["biz-card-landscape", "biz-card-portrait", "biz-card-square"],
  "loyalty-card": ["loyalty-card-landscape", "loyalty-card-portrait"],
  "sticker": ["sticker-landscape", "sticker-portrait", "sticker-square"],
  "instagram-post": ["insta-post"],
  "instagram-story": ["insta-story"],
  "facebook-post": ["fb-post"],
  "facebook-story": ["fb-story"],
  "tabletop-insert": ["table-tent", "table-tent-insert", "table-tent-insert-4x6"],
  "logo": ["logo"],
  "sandwich-board": ["sandwich-board"],
  "food-label": ["label-landscape", "label-portrait", "label-square"],
  "gift-certificate": ["gift-certificate-landscape"],
  "comment-card": ["comment-card-portrait"],
  "rack-card": ["rack-card-portrait"],
  "custom-size": ["custom"]
}`);

export const DigitalSizes = [
  "digital-menu-board",
  "digital-menu-board-portrait",
  "fb-post",
  "fb-story",
  "insta-post",
  "insta-story",
  "logo",
];

export const SocialSizes = [
  "fb-post",
  "fb-story",
  "insta-post",
  "insta-story",
  "logo",
];

export const DigiboardSizes = [
  "digital-menu-board",
  "digital-menu-board-portrait"
]

export const MaxFreemiumLinkPageViews = 300;

export const headerHeight = '80px';
export const mobileHeaderHeight = '60px';

export const homePaths = ['/home-test', '/home-test/', '/home-test/designs', '/home-test/designs/',
                          '/home', '/home/', '/home/designs', '/home/designs/', ]

const isLocalhost = window.location.href.match('localhost');
export const isTestEnv = window.location.href.match('test.mhmfun.com');
export const isStageEnv = window.location.href.match('staging.mhmfun.com');
export const isProdEnv = window.location.href.match('musthavemenus.com');

export const homePath = isLocalhost ? '' :
                        isTestEnv ? '/home-test' :
                        isStageEnv ? '/home-stage' :
                        '/home';

export const DESIGN_IN_USE_SECONDS = 45;
export const DSA_ENABLED =
  (window.localStorage.getItem('dsa')?.toUpperCase() === 'Y') ||
  (window.location.href.indexOf("localhost") > -1) ||
  (window.location.href.indexOf("test.mhmfun") > -1);

export const maxDesignPages = 100;

export const STRIPE_DEFAULT_SETTINGS = {
  appearance: {
    variables: {
      fontFamily: "proxima-nova",
      colorTextPlaceholder: "#d9d9d9",
      colorPrimary: "#e42436",
    }
  },
  fonts: [
    {
      family: "proxima-nova",
      src: 'url("https://use.typekit.net/af/705e94/00000000000000003b9b3062/27/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n4&v=3.woff")'
    },
  ]
}

export const DISABLE_USER_ADDONS = false;
